export const ADD_ERROR = 'ADD_ERROR';
export default function addError(id, error) {
  return {
    type: ADD_ERROR,
    id,
    error,
  };
}
